import React, { Component } from 'react';
import { 
    Button,
    Col,
    Container,
    FormGroup, 
    Input,
    InputGroup,
    InputGroupAddon,
    Label,
    Row } from "reactstrap";
import Cards from '../Cards';
import Speaker from '../Speaker';
import Mic from '../Mic';
import data from '../data/dialogflow.json'
import Popup from '../Popup/Popup'; 
import logo from '../../resources/math.png'


export default class Home extends Component {

  state = {
    richiesta: "",
    cards: [],
    testo: "",
    suggestions: [],
    context: [],
    reset: false,
    showPopup:true
  }

  togglePopup = () => {  
    this.setState({  
         showPopup: !this.state.showPopup  
    });  
  }   

  askIntent = () => {
    if(this.state.richiesta === ""){
      return;
    }
   
        var msgs = data['queryResult']['fulfillmentMessages'];
        console.log(msgs);
        var cards = [];
        var sugg = [];
        var text = "";
        var reset = false;
        var context = [];
        //read displayable information
        msgs.forEach((item) => {
          console.log(item);
          if(item['text'] !== undefined){
            console.log("text");
            text = item['text']['text'][0];
          }
          if(item['card'] !== undefined){
            console.log("card");
            cards.push(item['card']);
          }
          if(item['quickReplies'] !== undefined){
            console.log("reply");
            sugg = item['quickReplies']['quickReplies'];
          }
        });
        //read hidden context
        var cont = data['queryResult']['outputContexts'];
        cont.forEach((item) => {
          var item_split = item.name.split('/')
          if(item_split[item_split.length - 1] === 'reset_context'){ 
            reset = true;
          }else{
            context.push({
              name: item.name,
              lifespanCount: item.lifespanCount
            });
          }
        });

        this.setState({
          testo: text,
          cards: cards,
          suggestions: sugg,
          reset: reset,
          context: context,
          showPopup: false
        });
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  askSuggestion = (s) => {
	  this.setState(
      {
        richiesta: s['s']
      },
      () => {this.askIntent();}
    );
  }

  submitByEnter = (e) => {
    if(e.target.name === "richiesta" && e.keyCode === 13){
      this.askIntent();
    }
  }

  setReqByMic = (r) => {
    console.log("Mic Return "+r);
    this.setState(
      {
        richiesta: r
      },
      () => {this.askIntent();}
    );
  }

  render() {

    return (
      <React.Fragment>
        <Container className="main">  
            <Row>
              <Col xs={{size: 1}}>
                <img src={logo} style={iconSize} alt="Math" />
              </Col>
              <Col xs={{size: 10}}>
              <br />
                <FormGroup>
                    <InputGroup>
                        <InputGroupAddon addonType="prepend"><Mic setText={this.setReqByMic} /></InputGroupAddon>
                        <Input
                            autoFocus
                            name="richiesta"
                            type="text"
                            value={this.state.richiesta}
                            onChange={this.handleChange}
                            onKeyDown={this.submitByEnter}
                        />
                        <InputGroupAddon addonType="append"><Button onClick={(e) => {this.askIntent();}} color="primary">Ask</Button></InputGroupAddon>
                    </InputGroup> 
                </FormGroup>
              </Col>  
            </Row>
            <br />
            <Row>
              <Col xs={{size: 10, offset: 1}}>
                <Row>
                  <Col xs={{size: 10}}>
                    <p>{this.state.testo}</p>
                  </Col>
                  <Col xs={{size: 1}}>
                    <Speaker text={this.state.testo} />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={{size: 10, offset: 1}}>
                {
                  this.state.suggestions.length > 0 &&
                    <Label>You might also like: </Label>
                }
                {  
                  this.state.suggestions.map((s, i) => (
                    <Button key={i} className="suggestions" onClick={(e) => {this.askSuggestion({s});}} color="warning">{s}</Button>
                  ))
                }
              </Col>
            </Row>
            <br />
            <Row>
              <Col xs={{size: 10, offset: 1}}>
                <Cards cards={this.state.cards} />
              </Col>
            </Row>
            <div>
            {this.state.showPopup ?  
              <Popup  
                        text='You can make your question typing in the text field or clicking the microphone icon and speaking'  
                        text2='e.g. "what are decimal fractions?"'
                        closePopup={this.togglePopup}  
              />  
              : null  
              }  
            </div>
        </Container>
      </React.Fragment>
    );
  }
}

const iconSize = {
  width: '75px'
}